module.exports = "<div>\n    <div style=\"width: 300px; margin: auto;\" id=\"gbtn\"></div>\n</div>"